import StoreIcon from '@mui/icons-material/Store';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  TextField,
} from '@mui/material';
import React from 'react';

export const RefundFormMarketplace = ({
  isMP,
  marketplace,
  error,
  onChange,
}) => {
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(isMP)}
            checkedIcon={<StoreIcon />}
            icon={<StoreOutlinedIcon />}
            disabled
            size="large"
            color="success"
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={'Marketplace'}
      />
      {isMP && (
        <FormControl fullWidth error={Boolean(error)}>
          <TextField
            variant="outlined"
            size="small"
            value={marketplace?.name || ''}
            disabled
            label="Nom Marketplace"
            fullWidth
            helperText={error}
            error={Boolean(error)}
          />
        </FormControl>
      )}
    </>
  );
};
